import React, { PropsWithChildren } from 'react';
import { Text } from '@cardboard-ui/react';

interface ListItemMainTextProps {
  isProminent?: boolean;
  variant?: 'CTA' | 'danger' | 'unactionable' | 'default';
}
export const ListItemMainText: React.FC<
  PropsWithChildren<ListItemMainTextProps>
> = ({ isProminent, variant, children }) => {
  let color;
  if (variant === 'CTA') {
    color = 'blue.500';
  } else if (variant === 'danger') {
    color = 'status.error';
  }
  return (
    <Text
      noOfLines={1}
      color={color}
      fontSize="md"
      fontWeight={isProminent ? 'bold' : 'normal'}
      fontStyle={variant === 'unactionable' ? 'italic' : ''}
      display="block"
    >
      {children}
    </Text>
  );
};
